import consts from "@/consts.js";
import Request from './request';

async function fetch(data){
    return Request('get','api/stock-roadways',data)
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-roadways", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-roadways/select", data, false, false, true);
}

async function save(id,data){
    if(id){
        return Request('post','api/stock-roadways/edit?id=' + id,data);
    }else{
        return Request('post','api/stock-roadways/add',data)
    }
}

async function fetchOne(data, noLoading, noResponseError) {// 获取单个
    return Request('get', "api/stock-roadways/view", data, noLoading, noResponseError);
}

async function del(id) {
    return Request('delete', "api/stock-roadways/delete/" + id);
}

export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    save,
    fetchOne,
    del
}